const rewardMessage = ({ vm, base, photo, video }) => {
  const rewards = [];
  if (base) rewards.push(vm.$t('mileage_notice.base_reward', [base]));
  if (photo) rewards.push(vm.$t('mileage_notice.photo_reward', [photo]));
  if (video) rewards.push(vm.$t('mileage_notice.video_reward', [video]));
  return rewards.join(', ');
};

const getConditionKeys = ({
  enable_min_product_price,
  enable_min_order_price
}) =>
  enable_min_product_price && enable_min_order_price
    ? {
        high: 'mileage_notice.condition_min_product_order',
        low: 'mileage_notice.condition_min_product_order_low'
      }
    : enable_min_product_price
    ? {
        high: 'mileage_notice.condition_min_product',
        low: 'mileage_notice.condition_min_product_low'
      }
    : enable_min_order_price
    ? {
        high: 'mileage_notice.condition_min_order',
        low: 'mileage_notice.condition_min_order_low'
      }
    : null;

const headerLine = ({ vm, segments, index, position }) => {
  const min_message_length = segments[index].min_message_length;

  if (index === 0) {
    return vm.$t('mileage_notice.header_lower_bound', {
      position,
      min_message_length
    });
  }

  const max_message_length = segments[index - 1].min_message_length;

  if (index < segments.length - 1) {
    return vm.$t('mileage_notice.header_range', {
      position,
      min_message_length,
      max_message_length
    });
  }

  return vm.$t('mileage_notice.header_upper_bound', {
    position,
    max_message_length
  });
};

const segmentLines = ({ vm, segments, index, position, conditionKeys }) => {
  const segment = segments[index];
  const lines = [];
  lines.push(headerLine({ vm, segments, index, position }));

  if (conditionKeys) {
    lines.push(
      vm.$t(conditionKeys.high, {
        min_product_price: segment.min_product_price,
        min_order_price: segment.min_order_price
      })
    );
    lines.push(
      vm.$t('mileage_notice.reward', [
        rewardMessage({
          vm,
          base: segment.base_reward,
          photo: segment.photo_reward,
          video: segment.video_reward
        })
      ])
    );

    if (
      segment.base_reward_low ||
      segment.photo_reward_low ||
      segment.video_reward_low
    ) {
      lines.push(
        vm.$t(conditionKeys.low, {
          min_product_price: segment.min_product_price,
          min_order_price: segment.min_order_price
        })
      );
      lines.push(
        vm.$t('mileage_notice.reward', [
          rewardMessage({
            vm,
            base: segment.base_reward_low,
            photo: segment.photo_reward_low,
            video: segment.video_reward_low
          })
        ])
      );
    }
  } else {
    lines.push(
      vm.$t('mileage_notice.reward', [
        rewardMessage({
          vm,
          base: segment.base_reward,
          photo: segment.photo_reward,
          video: segment.video_reward
        })
      ])
    );
  }
  return lines;
};

const buildMessage = (vm, data) => {
  if (data.mileage_message) return data.mileage_message;
  if (!data.reward_segments.length) return '';

  let position = 0;
  const conditionKeys = getConditionKeys({
    enable_min_product_price: data.enable_min_product_price,
    enable_min_order_price: data.enable_min_order_price
  });
  const segments = data.reward_segments;
  const rewardLines = segments.flatMap((segment, index) => {
    if (
      segment.base_reward === 0 &&
      segment.photo_reward === 0 &&
      segment.video_reward === 0
    )
      return [];

    position += 1;
    return segmentLines({ vm, segments, index, position, conditionKeys });
  });

  return [
    ...rewardLines,
    ...(data.has_multiple_forms ? [vm.$t('mileage_notice.multiple_forms')] : [])
  ].join('\n');
};

export default {
  methods: {
    async fetchMileageNotice() {
      const { data } = await this.$store.state.api.fetchMileageMessage();
      const message = buildMessage(this, data);
      if (!message) return null;

      return {
        title: this.$t('mileage_notice.title', { brand_name: data.brand_name }),
        message
      };
    }
  }
};
